document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('#productGridContainer .product-grid');
  const button = document.querySelector('#loadMore');
  const productCount = document.querySelector('#productCount');

  if (!grid || !button) return;

  const pageSize = parseInt(button.dataset.pageSize, 10);
  const totalItems = parseInt(button.dataset.totalItems, 10);
  let loadedCount = grid.querySelectorAll('.product-grid > *').length;
  let currentPage = 1;

  // Your confirmed section ID
  const sectionId = 'template--25516803457320__main';

  async function fetchNextPage(page) {
    const url = `${window.location.pathname}?page=${page}&section_id=${sectionId}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const html = await res.text();
    return new DOMParser().parseFromString(html, 'text/html');
  }

  button.addEventListener('click', async () => {
    const nextPage = currentPage + 1;
    button.disabled = true;
    const prevText = button.textContent;
    button.textContent = 'LOADING';

    try {
      const doc = await fetchNextPage(nextPage);
      const newItems = doc.querySelectorAll('.product-grid > *');

      // Append products
      newItems.forEach(item => {
        item.classList.add('fade-in-product');
        grid.appendChild(item);
      });

      loadedCount += newItems.length;
      const remaining = Math.max(totalItems - loadedCount, 0);
      const showing = Math.min(loadedCount, totalItems);

      if (productCount) {
        productCount.textContent = `Showing ${showing} of ${totalItems} products`;
      }

      // Button always reads "LOAD MORE"
      if (remaining > 0 && newItems.length > 0) {
        button.textContent = 'LOAD MORE';
        button.disabled = false;
        currentPage = nextPage;
      } else {
        button.remove();
      }

    } catch (err) {
      console.error('Load More error:', err);
      button.textContent = prevText;
      button.disabled = false;
    }
  });
});
